import swal from "sweetalert2";
import documentStatus from "@/constants/signatureStatuses";
import { AWSAmplify } from "../services/cofigureAWSAmplify";
import { datadogRum } from "@datadog/browser-rum";
import Vue from "vue";
import { getParticipantDataFactV2 } from "@/api/participants";
import { getSiteDetailsFact } from "@/api/sites";
import localStorageService from "@/services/localStorage";
import { getInstantUserDataFact, getValidateUserData } from "@/api/users";

export const tokensWhichAllowedToRoute = [
  "createPassword",
  "forgotPassword",
  "login",
  "resetPassword",
  "forgot-password-otp",
  "reset-password-otp",
  "participant-reset-password",
  "verify-participant",
  "verify-participant-v2",
  "verify-participant-v3",
  "unsubscribeemail",
  "privacy-policy",
  "terms-of-use",
  "complete-registration",
  "get-create-username-link",
  "create-username",
  "forgot-password-via-username",
  "forgot-username",
  "create-password-aws",
  "dont-have-username",
  "verify-identity",
  "page-not-found",
  "participants-web-sign",
  "participants-portal",
  "participants-web-login",
  "participants-auth-login",
  "participants-portal-auth-login",
  "participants-portal-auth-registration",
  "participants-portal-auth-location",
  "participants-portal-auth-forgot-password",
  "participants-portal-auth-forgot-username",
  "participants-portal-login",
  "participants-web-join",
  "participants-portal-auth-join",
  "participants-portal-web-login",
  "participants-portal-register",
  "participants-portal-reset-password",
  "participants-portal-forgot-username",
  "participants-portal-register",
  "ssologin"
];

export const awsAuthenticationFlowRoutes = ["complete-registration", "get-create-username-link", "create-username", "forgot-password-via-username", "forgot-username", "create-password-aws", "dont-have-username", "verify-identity"];

export const beforeEach = ({ store, api, toastr }) => async (to, from, next) => {
  if (process.env.VUE_APP_DD_WEB_PORTAL_APP_ID && process.env.VUE_APP_DD_WEB_PORTAL_APP_ID != "") {
    if (Vue.http && Vue.http.headers && Vue.http.headers.common && Vue.http.headers.common.clientId) {
      datadogRum.addRumGlobalContext("clientId", Vue.http.headers.common.clientId);
    }
    if (to.params.studyId) {
      datadogRum.addRumGlobalContext("studyId", to.params.studyId);
    }
  }
  // get client ID on required pages and if user is not logged in
  if (!store.getters.token) {
    if (tokensWhichAllowedToRoute.indexOf(to.name) === -1) {
      const nxtRoute = {
        name: "ssologin"
      };
      if ((to.name && to.name.includes("participants-portal")) || to.path.includes("/participants/web/")) {
        nxtRoute.name = "participants-portal-web-login";
        nxtRoute.path = "/participants/web/login";
      }
      const isLogOut = window.localStorage.getItem("thread-logOut");
      window.localStorage.removeItem("thread-logOut");
      if (from.name == null && !isLogOut) {
        nxtRoute.query = {
          redirectTo: to.path
        };
      }
      next(nxtRoute);
    } else if (tokensWhichAllowedToRoute.indexOf(to.name) >= 0 && from.name != "ssologin") {
      await api
        .getClientIdFact()
        .then(async result => {
          if (process.env.VUE_APP_DD_WEB_PORTAL_APP_ID && process.env.VUE_APP_DD_WEB_PORTAL_APP_ID != "") {
            datadogRum.addRumGlobalContext("clientId", result.body.id);
          }
          store.dispatch("clientIdSuccess", result.body.id);
          store.dispatch("clientName", result.body.name);
          store.dispatch("setmultiFactorEnableFlag", result.body.isTwoFAEnabled);
          if (result.body.isCognitoAuthentication) {
            const cognitoFlag = Boolean(result.body.isCognitoAuthentication);
            store.dispatch("setAwsAuthenticationFlow", cognitoFlag);
            if (cognitoFlag === true) {
              //Check whether PwebCognitoflag is true also
              if (result.body.isParticipantUsesCognito && result.body.isParticipantUsesCognito == true) {
                store.dispatch("setPWEBCognitoFlag", true);
              } else {
                store.dispatch("setPWEBCognitoFlag", false);
              }

              if (to.path.includes("/participants/web/") && result.body.isParticipantUsesCognito && result.body.isParticipantUsesCognito == true) {
                const amplify = new AWSAmplify();
                await amplify.configureAWSAmplifyParticipant();
              } else {
                const amplify = new AWSAmplify();
                await amplify.configureAWSAmplify();
              }
            }
          } else {
            store.dispatch("setAwsAuthenticationFlow", false);
            store.dispatch("setPWEBCognitoFlag", false);
          }
        })
        .catch(error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting clients.");
        });
    }
  }
  if (!store.getters.awsCognitoAuthentication && awsAuthenticationFlowRoutes.indexOf(to.name) >= 0) {
    const nxtRoute = {
      name: "page-not-found"
    };
    next(nxtRoute);
  } // before each route hook
  else if (from.name) {
    if (
      (from.name.includes("configure-new-form") && !to.name.includes("configure-new-form") && ((JSON.parse(window.localStorage.getItem("thread-edcData")) && JSON.parse(window.localStorage.getItem("thread-edcData").length)) || (window.localStorage.getItem("thread-edcFormName") && window.localStorage.getItem("thread-edcFormName").length))) ||
      JSON.parse(window.localStorage.getItem("thread-edcFormEditMode"))
    ) {
      swal({
        title: "You have not saved your progress. Are you sure you want to leave? Your changes will not be saved. ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          next(false);
        }
        if (!dismiss) {
          store.dispatch("clearEDCData");
          next();
        }
      });
    } else if (from.name.includes("participant-document") && !to.name.includes("participant-document")) {
      const clearSignData = () => {
        store.dispatch("setSignatureStatusAction", null);
        store.dispatch("setSignatureAction", null);
        store.dispatch("setBase64SignatureAction", null);
      };
      if (store.getters.getSignatureStatus == documentStatus.SIGNATURE_ACQUIRED) {
        swal({
          title: "Are you sure you want to cancel?<br> Any provided responses won't be saved. ",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#34537d",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            clearSignData();
            next();
          }
          if (!dismiss) {
            next(false);
          }
        });
      } else {
        clearSignData();
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
};

export const isAssignedToParticipantSite = async ({ studyId, participantId }) => {
  const userObj = localStorageService.getItem("userObj");
  const response = {
    isAllowed: true,
    message: ``
  };
  /**
   * userObj from localStorage only gets update after signing in
   * make an API call to get the current data access type if toggles where changed
   * during the user's session
   * **/
  const userData = await getInstantUserDataFact(userObj.id);
  const userDetails = userData.body;
  if (userDetails.userStudies && userDetails.userStudies.length) {
    // TODO: refactor this to remove unnecessary checks for the same error message
    const message = "You do not have access to this page.";
    try {
      const userStudy = userDetails.userStudies.find(study => study.studyId === studyId);
      if (!userStudy) {
        return {
          isAllowed: false,
          message
        };
      }
      const participantData = await getParticipantDataFactV2(studyId, participantId);
      const participantSiteId = participantData.body.siteId;
      if (userStudy.assignedSiteIds && userStudy.assignedSiteIds.length) {
        const assignedSiteIds = userStudy.assignedSiteIds;
        if (!assignedSiteIds.includes(participantSiteId)) {
          return {
            isAllowed: false,
            message
          };
        }
      }
      if (userStudy.userDataAccessType !== "BOTH") {
        const siteDetails = await getSiteDetailsFact(studyId, participantSiteId);
        const siteSubType = siteDetails.body.siteSubType;
        if (userStudy.userDataAccessType !== siteSubType) {
          return {
            isAllowed: false,
            message
          };
        }
      }
    } catch {
      return {
        isAllowed: false,
        message
      };
    }
  }
  return response;
};

export const isUserAllowed = async ({ studyId } = {}) => {
  try {
    await getValidateUserData({ studyId });
    return true;
  } catch (error) {
    throw new Error(error.body && error.body.message);
  }
};
